export default __webpack_public_path__ + "static/events-light-0036053998d6d063b853127c820c8130.png";